// extracted by mini-css-extract-plugin
export default {"card":"ImgCardMobile_card__4tH3-","card-wrapper":"ImgCardMobile_card-wrapper__AhR97","closeBtn":"ImgCardMobile_closeBtn__mVF60","error":"ImgCardMobile_error__C6y7u"};